import React from 'react';
import get from 'lodash/get';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Subject} from 'rxjs/Subject';
import {createSelector} from 'reselect';
import compose from 'recompose/compose';
import {FormattedMessage} from 'react-intl';
import {bool, func, string} from 'prop-types';
import setDisplayName from 'recompose/setDisplayName';
import {Modal, Button, TextArea, Label} from 'semantic-ui-react';
import {EmptyFunc} from 'utils/DBUtils';
import {TEXT_INPUT_DEBOUNCE_TIME} from 'Config';

class EditWinnerStoryModal extends React.Component {
  static propTypes = {
    isOpen: bool.isRequired,
    isInFlight: bool.isRequired,
    handleClose: func.isRequired,
    hasSaveError: bool.isRequired,
    handleSubmit: func.isRequired,
    winnerStory: string.isRequired
  };

  state = {
    winnerStory: null
  };

  changeEmitter = new Subject().debounceTime(TEXT_INPUT_DEBOUNCE_TIME);

  handleChange = (event, data) => {
    this.changeEmitter.next(data.value);
  };

  handleClose = (event, data) => {
    if (!this.props.isInFlight) {
      this.props.handleClose();
    }
  };

  handleSubmit = (event, data) => {
    this.props.handleSubmit(this.state.winnerStory);
  };

  componentDidMount() {
    this.setState({winnerStory: this.props.winnerStory});
    this.changeEmitter.subscribe(winnerStory => this.setState({winnerStory}));
  }

  get className() {
    return classnames('primary-modal edit-winner-story-modal', {
      'error-modal': this.props.hasSaveError
    });
  }

  get canSubmit() {
    return !(this.props.isInFlight || this.props.hasSaveError);
  }

  render() {
    return (
      <Modal
        size='tiny'
        dimmer={true}
        closeIcon={true}
        open={this.props.isOpen}
        closeOnDimmerClick={true}
        onClose={this.handleClose}
        className={this.className}>
        <Modal.Header>
          <FormattedMessage id='winnersList.modal.editStory.header' />
        </Modal.Header>
        <Modal.Content>
          {this.props.hasSaveError && (
            <Label className='db-error-label'>
              <FormattedMessage id='winnersList.modal.editStory.error' />
            </Label>
          )}
          <TextArea
            onChange={this.handleChange}
            value={this.state.winnerStory} />
          <Button
            primary={true}
            disabled={!this.canSubmit}
            onClick={this.handleSubmit}
            loading={this.props.isInFlight}>
            <FormattedMessage id='buttons.save' />
          </Button>
        </Modal.Content>
      </Modal>
    );
  }
}

const selectWinnerStory = createSelector(
  state => state.resources.resources[state.listWinners.currentWinnerId],
  currentWinner => {
    const {winnerStory, winnerStoryRecords, lang} = currentWinner;

    if (winnerStoryRecords && winnerStoryRecords.length > 0) {
      // if there are edited or translated versions of this story, find it by lang.
      const {story: editedWinnerStory} = winnerStoryRecords.find(story => story.lang === lang);
      return editedWinnerStory;
    } else {
      // otherwise just return the original.
      return winnerStory;
    }
  }
);

export default compose(
  setDisplayName('EditWinnerStoryModal'),
  connect(state => ({
    winnerStory: selectWinnerStory(state)
  }))
)(EditWinnerStoryModal);



// WEBPACK FOOTER //
// ./public/pages/ListWinners/EditWinnerStoryModal.jsx